import axios from "axios";
import Cookies from "js-cookie";
// import { useAuth } from "./hooks/useAuth";

// const { token } = useAuth()
const axiosFetch = ()=>{
    
    let headers ={
        'X-Requested-With': 'XMLHttpRequest',
        }
    
    // let headers ={
    //     "Authorization":"",
    //     "X-CSRFToken":"",
    //     'X-Requested-With': 'XMLHttpRequest',
    //     }
    const csrftoken = Cookies.get("csrftoken")
    
    // if(token){
    //     headers["Authorization"] = `Bearer ${token}`
    // }
    if(csrftoken){
        headers["X-CSRFToken"] = `${csrftoken}`
    }
    // if(isMultipart){
    //     headers["Content-Type"] = "multipart/form-data"
    // }

    // console.log(headers)
    const axiosInstance = axios.create({
        // "https://work-record-manager.herokuapp.com"
        // baseURL: "http://127.0.0.1:8000",
        // baseURL:"https://144.126.201.198",
        // baseURL:"https://178.128.35.136",
        baseURL:"https://fountainafrica.org",
        
        // baseURL:"http://learningcenter.beaconscholars.co.ke",
        // credentials: "include",
        headers:headers,
        // method:method,
        // data:data,
        // url:endpoint
    })
    axiosInstance.defaults.headers.common.accept = 'application/json'
    return axiosInstance
}

export default axiosFetch